<div
    [id]="id + '.' + filter.id"
    class="agpr-filterCheckboxes agpr-agentsFilter"
>
    <agpr-filter-include-exclude
        [(ngModel)]="filter.currentIncludeExclude"
        (ngModelChange)="currentIncludeExcludeChange()"
    ></agpr-filter-include-exclude>
    <label class="agpr-filterCheckboxes-search">
        <agpr-text-input
            [id]="id + '.' + filter.id + '.search'"
            icon="fa-regular fa-duotone fa-magnifying-glass"
            [(ngModel)]="searchQuery"
            (ngModelChange)="search()"
            ariaLabel="Monitoring.filtersLocalization.aiAgents.search"
        ></agpr-text-input>
    </label>
    @if (filteredOptions.length > 0 && !isScoped) {
        <div class="agpr-filterCheckboxes-toggleContainer">
            <agpr-button
                [id]="id + '.' + filter.id + (anyOptionsSelected ? '.selectNone' : '.selectAll')"
                class="agpr-filterCheckboxes-allToggle"
                (click)="selectItems()"
                aria-live="polite"
                [style]="buttonTypes.link"
                [label]="(anyOptionsSelected ? 'selectNone' : 'selectAll') | localize"
            ></agpr-button>
        </div>
    }
    <agpr-scroll-panel>
        @if (filteredOptions.length < 1) {
            <div class="agpr-filterCheckboxes-noContent">
                <agpr-message [severity]="severity.noContent">
                    {{ 'Common.filter.noContent' | localize }}
                </agpr-message>
            </div>
        }
        <ul class="agpr-filterCheckboxes-list" [attr.aria-label]="'filter' | localize">
            @for (option of filteredOptions; track option.id; let i = $index) {
                <li>
                    <div class="agpr-filterCheckboxes-item">
                        @if (hasChildren(option)) {
                            <ng-container
                                [ngTemplateOutlet]="expandButton"
                                [ngTemplateOutletContext]="{ option: option, buttonId: id + '_' + filter.id + '_expand-' + i, label: option.name }"
                            ></ng-container>
                        } @else {
                            <span class="agpr-agentsFilter-expandSpacer" aria-hidden="true"></span>
                        }
                        <agpr-checkbox
                            [id]="id + '_' + filter.id + '_checkbox-' + i"
                            class="agpr-filterCheckboxes-checkbox"
                            [binary]="true"
                            [label]="option.name"
                            [disabled]="isScoped"
                            [ngModel]="isAgentSelected(option)"
                            [partialSelected]="isAgentPartial(option)"
                            (ngModelChange)="toggleAgent(option, $event)"
                        >
                            @if (filter.countFor(option.id) !== null) {
                                <span
                                    class="agpr-filterCheckboxes-itemCount"
                                    [pTooltip]="filter.countFor(option.id) | number"
                                >{{ filter.countFor(option.id) | significantDigits : 1 }}</span>
                            }
                        </agpr-checkbox>
                    </div>

                    @if (hasChildren(option) && isExpanded(option)) {
                        <ul
                            class="agpr-agentsFilter-children"
                            [attr.aria-label]="'Monitoring.filtersLocalization.aiAgents.sources' | localize: { agent: option.name }"
                        >
                            <!-- Live Sources: the agent's sources, and Other for those it no longer has -->
                            @if (!isExcluding || option.sources.length > 0) {
                                <li>
                                    <div class="agpr-filterCheckboxes-item">
                                        <ng-container
                                            [ngTemplateOutlet]="expandButton"
                                            [ngTemplateOutletContext]="{
                                                option: option,
                                                group: groups.liveSources,
                                                buttonId: id + '_' + filter.id + '_expand-' + i + '_liveSources',
                                                label: 'Monitoring.filtersLocalization.aiAgents.liveSources' | localize
                                            }"
                                        ></ng-container>
                                        <agpr-checkbox
                                            [id]="id + '_' + filter.id + '_checkbox-' + i + '_liveSources'"
                                            class="agpr-filterCheckboxes-checkbox"
                                            [binary]="true"
                                            label="Monitoring.filtersLocalization.aiAgents.liveSources"
                                            [ngModel]="isGroupSelected(option, groups.liveSources)"
                                            [partialSelected]="isGroupPartial(option, groups.liveSources)"
                                            (ngModelChange)="toggleGroup(option, groups.liveSources, $event)"
                                        ></agpr-checkbox>
                                    </div>

                                    @if (isExpanded(option, groups.liveSources)) {
                                        <ul class="agpr-agentsFilter-children">
                                            @for (source of option.sources; track source.id; let j = $index) {
                                                <li class="agpr-filterCheckboxes-item">
                                                    <span class="agpr-agentsFilter-expandSpacer" aria-hidden="true"></span>
                                                    <agpr-checkbox
                                                        [id]="id + '_' + filter.id + '_checkbox-' + i + '_source-' + j"
                                                        class="agpr-filterCheckboxes-checkbox"
                                                        [binary]="true"
                                                        [label]="source.label"
                                                        [ngModel]="isSourceSelected(option, source)"
                                                        (ngModelChange)="toggleSource(option, source, $event)"
                                                    >
                                                        @if (filter.sourceCountFor(option.id, source.id) !== null) {
                                                            <span
                                                                class="agpr-filterCheckboxes-itemCount"
                                                                [pTooltip]="filter.sourceCountFor(option.id, source.id) | number"
                                                            >{{ filter.sourceCountFor(option.id, source.id) | significantDigits : 1 }}</span>
                                                        }
                                                    </agpr-checkbox>
                                                </li>
                                            }
                                            @if (!isExcluding) {
                                                <li class="agpr-filterCheckboxes-item">
                                                    <span class="agpr-agentsFilter-expandSpacer" aria-hidden="true"></span>
                                                    <agpr-checkbox
                                                        [id]="id + '_' + filter.id + '_checkbox-' + i + '_other'"
                                                        class="agpr-filterCheckboxes-checkbox agpr-agentsFilter-other"
                                                        [binary]="true"
                                                        label="Monitoring.filtersLocalization.aiAgents.other"
                                                        infoCircleTooltip="Monitoring.filtersLocalization.aiAgents.other.tooltip"
                                                        [ngModel]="isOtherSelected(option)"
                                                        (ngModelChange)="toggleOther(option, $event)"
                                                    ></agpr-checkbox>
                                                </li>
                                            }
                                        </ul>
                                    }
                                </li>
                            }

                            @if (option.adHocRuns.length > 0) {
                                <li>
                                    <div class="agpr-filterCheckboxes-item">
                                        <ng-container
                                            [ngTemplateOutlet]="expandButton"
                                            [ngTemplateOutletContext]="{
                                                option: option,
                                                group: groups.adHocRuns,
                                                buttonId: id + '_' + filter.id + '_expand-' + i + '_adHocRuns',
                                                label: 'AutomationAgents.agent.adHocEvents' | localize
                                            }"
                                        ></ng-container>
                                        <agpr-checkbox
                                            [id]="id + '_' + filter.id + '_checkbox-' + i + '_adHocRuns'"
                                            class="agpr-filterCheckboxes-checkbox"
                                            [binary]="true"
                                            label="AutomationAgents.agent.adHocEvents"
                                            [ngModel]="isGroupSelected(option, groups.adHocRuns)"
                                            [partialSelected]="isGroupPartial(option, groups.adHocRuns)"
                                            (ngModelChange)="toggleGroup(option, groups.adHocRuns, $event)"
                                        ></agpr-checkbox>
                                    </div>

                                    @if (isExpanded(option, groups.adHocRuns)) {
                                        <ul class="agpr-agentsFilter-children">
                                            @for (run of option.adHocRuns; track run.id; let j = $index) {
                                                <li class="agpr-filterCheckboxes-item">
                                                    <span class="agpr-agentsFilter-expandSpacer" aria-hidden="true"></span>
                                                    <agpr-checkbox
                                                        [id]="id + '_' + filter.id + '_checkbox-' + i + '_adHoc-' + j"
                                                        class="agpr-filterCheckboxes-checkbox"
                                                        [binary]="true"
                                                        [label]="run.label"
                                                        [ngModel]="isAdHocSelected(option, run)"
                                                        (ngModelChange)="toggleAdHoc(option, run, $event)"
                                                    ></agpr-checkbox>
                                                </li>
                                            }
                                        </ul>
                                    }
                                </li>
                            }
                        </ul>
                    }
                </li>
            }
        </ul>
    </agpr-scroll-panel>
</div>

<ng-template #expandButton let-option="option" let-group="group" let-buttonId="buttonId" let-label="label">
    <agpr-button
        [id]="buttonId"
        class="agpr-agentsFilter-expand"
        [style]="buttonTypes.icon"
        [icon]="isExpanded(option, group) ? 'fa-solid fa-angle-down' : 'fa-solid fa-angle-right'"
        [ariaLabel]="label"
        [attr.aria-expanded]="isExpanded(option, group)"
        (click)="toggleExpanded(option, group)"
    ></agpr-button>
</ng-template>
